/**
 * UI 글자가 박스를 넘치지 않게 줄이거나 자른다.
 * 한글은 모노 폰트에 글리프가 없어 폭이 커지므로 반드시 maxWidth 를 건다.
 */
import type Phaser from 'phaser';

export function wrap(width: number): { wordWrap: { width: number; useAdvancedWrap: boolean } } {
  return { wordWrap: { width, useAdvancedWrap: true } };
}

function baseSize(text: Phaser.GameObjects.Text): number {
  const stored = text.getData('fitFont');
  if (typeof stored === 'number') return stored;
  const raw = text.style.fontSize;
  const n = typeof raw === 'number' ? raw : parseInt(String(raw), 10);
  const size = Number.isFinite(n) ? n : 14;
  text.setData('fitFont', size);
  return size;
}

/** 너비에 맞게 폰트를 줄이고, 그래도 넘치면 … 로 자른다. */
export function fitText(text: Phaser.GameObjects.Text, maxWidth: number, minPx = 10): void {
  if (maxWidth <= 8) return;
  const start = baseSize(text);
  text.setFontSize(start);
  let size = start;
  while (text.displayWidth > maxWidth && size > minPx) {
    size -= 1;
    text.setFontSize(size);
  }
  if (text.displayWidth <= maxWidth) return;
  let s = text.text;
  while (s.length > 1 && text.displayWidth > maxWidth) {
    s = s.slice(0, -1);
    text.setText(`${s}…`);
  }
}

export function setFitted(
  text: Phaser.GameObjects.Text,
  value: string,
  maxWidth: number,
  minPx = 10,
): void {
  text.setFontSize(baseSize(text));
  text.setText(value);
  fitText(text, maxWidth, minPx);
}
